export const CandidateApiUrls = {
  getCandidateById: "candidate/GetCandidateById",
  getCommentsByCandidateId: "comment/getCommentsByCandidateId",
  upsertComment: "comment/UpsertComment",
  deleteComment: "comment/deleteComment",
  deleteCandidateCv: "candidate/deleteCandidateCv",
  saveInterviewFeedback: "candidate/SaveInterviewFeedback",
  getInterviewFeedback: "candidate/GetInterviewFeedback",
  getInterviewFeedbackById: "candidate/GetInterviewFeedbackById",
  deleteInterviewFeedback: "candidate/DeleteInterviewFeedback",
};

export default class candidateAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getCandidateById(data, token) {
    return this.get(CandidateApiUrls.getCandidateById, data, token);
  }

  async getCommentsByCandidateId(data, token) {
    return this.get(CandidateApiUrls.getCommentsByCandidateId, data, token);
  }

  async upsertComment(data, token) {
    return this.post(CandidateApiUrls.upsertComment, data, token);
  }

  async deleteComment(data, token) {
    return this.get(CandidateApiUrls.deleteComment, data, token);
  }

  async deleteCandidateCv(data, token) {
    return this.get(CandidateApiUrls.deleteCandidateCv, data, token, true, true);
  }

  async saveInterviewFeedback(data, token) {
    return this.post(CandidateApiUrls.saveInterviewFeedback, data, token, false, true);
  }

  async getInterviewFeedback(data, token) {
    return this.get(CandidateApiUrls.getInterviewFeedback, data, token);
  }

  async getInterviewFeedbackById(data, token) {
    return this.get(CandidateApiUrls.getInterviewFeedbackById, data, token);
  }

  async deleteInterviewFeedback(data, token) {
    return this.get(CandidateApiUrls.deleteInterviewFeedback, data, token, false, true);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
